
export type ConnectivityTest200 = {[key: string]: boolean};
